module.exports = __webpack_public_path__ + "static/media/br-rn.f4f3ecc3.svg";